var _rect, _rect2, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3148_7032)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3148_7032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3148_7032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8501 15.15V14.3321C5.8501 13.9643 6.0376 13.667 6.4126 13.4402C6.7876 13.2134 7.27668 13.1 7.87985 13.1H8.0251C8.06676 13.1 8.1126 13.1027 8.1626 13.1081C8.07926 13.2777 8.01601 13.4513 7.97285 13.629C7.92968 13.8068 7.9081 13.9922 7.9081 14.1853V15.15H5.8501ZM8.8501 15.15V14.1875C8.8501 13.8958 8.9251 13.6292 9.0751 13.3875C9.2251 13.1458 9.44176 12.9375 9.7251 12.7625C10.0084 12.5875 10.343 12.4542 10.7287 12.3625C11.1146 12.2708 11.5372 12.225 11.9966 12.225C12.4649 12.225 12.8899 12.2708 13.2715 12.3625C13.6531 12.4542 13.9877 12.5875 14.2751 12.7625C14.5584 12.9375 14.7751 13.1458 14.9251 13.3875C15.0751 13.6292 15.1501 13.8958 15.1501 14.1875V15.15H8.8501ZM16.0876 15.15V14.1821C16.0876 13.9838 16.0668 13.7958 16.0251 13.6181C15.9834 13.4405 15.9251 13.2708 15.8501 13.1091C15.9001 13.103 15.947 13.1 15.9908 13.1H16.1251C16.7393 13.1 17.2303 13.2127 17.5982 13.4381C17.9661 13.6635 18.1501 13.9633 18.1501 14.3375V15.15H16.0876ZM10.0251 14.15H13.9751V14.075C13.9084 13.8083 13.698 13.5979 13.3438 13.4437C12.9897 13.2896 12.5418 13.2125 12.0001 13.2125C11.4584 13.2125 11.0105 13.2917 10.6563 13.45C10.3022 13.6083 10.0918 13.8208 10.0251 14.0875V14.15ZM7.87235 12.7625C7.60751 12.7625 7.38135 12.6674 7.19385 12.4771C7.00635 12.2869 6.9126 12.0582 6.9126 11.791C6.9126 11.522 7.00685 11.2938 7.19535 11.1063C7.38393 10.9188 7.6106 10.825 7.87535 10.825C8.14185 10.825 8.37093 10.9189 8.5626 11.1067C8.75426 11.2945 8.8501 11.5235 8.8501 11.7939C8.8501 12.0563 8.75535 12.2833 8.56585 12.475C8.37635 12.6667 8.14518 12.7625 7.87235 12.7625ZM16.1223 12.7625C15.8575 12.7625 15.6313 12.6674 15.4438 12.4771C15.2563 12.2869 15.1626 12.0582 15.1626 11.791C15.1626 11.522 15.2568 11.2938 15.4453 11.1063C15.6339 10.9188 15.8606 10.825 16.1253 10.825C16.3918 10.825 16.6209 10.9189 16.8126 11.1067C17.0043 11.2945 17.1001 11.5235 17.1001 11.7939C17.1001 12.0563 17.0053 12.2833 16.8158 12.475C16.6263 12.6667 16.3952 12.7625 16.1223 12.7625ZM12.0062 11.8625C11.5462 11.8625 11.1552 11.7015 10.8331 11.3795C10.5111 11.0574 10.3501 10.6664 10.3501 10.2064C10.3501 9.74379 10.5111 9.35417 10.8331 9.0375C11.1552 8.72083 11.5462 8.5625 12.0062 8.5625C12.4688 8.5625 12.8584 8.72083 13.1751 9.0375C13.4918 9.35417 13.6501 9.74379 13.6501 10.2064C13.6501 10.6664 13.4918 11.0574 13.1751 11.3795C12.8584 11.7015 12.4688 11.8625 12.0062 11.8625ZM12.0107 10.8625C12.187 10.8625 12.3397 10.7981 12.4688 10.6692C12.598 10.5405 12.6626 10.3842 12.6626 10.2005C12.6626 10.0168 12.5969 9.8625 12.4655 9.7375C12.334 9.6125 12.1803 9.55 12.0045 9.55C11.8182 9.55 11.6626 9.61283 11.5376 9.7385C11.4126 9.86417 11.3501 10.0199 11.3501 10.2058C11.3501 10.3853 11.412 10.5396 11.5357 10.6688C11.6595 10.7979 11.8178 10.8625 12.0107 10.8625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3148_7032",
    x1: 2.44698,
    y1: 2.145,
    x2: 21.4586,
    y2: 21.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003993"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleNew);
export default __webpack_public_path__ + "static/media/people_new.36c7e7cee6bad5c63ea197edfe55c4a4.svg";
export { ForwardRef as ReactComponent };